/* OP Blog Carousel — mouse drag-to-scroll.
 *
 * The slider runs Swiper in cssMode, so trackpad / wheel / touch already scroll
 * the .swiper-wrapper natively. This adds click-and-drag with the mouse only.
 *
 * Why pointer events in the capture phase on document:
 *   Swiper calls preventDefault() on pointerdown (touchStartPreventDefault), which
 *   suppresses the synthetic mouse events (mousedown/mousemove/click). Listening for
 *   pointer events during capture lets us react before Swiper, on a channel it can't
 *   suppress. We only handle pointerType === 'mouse' so touch/trackpad stay native.
 *
 * Why we toggle scroll-behavior/scroll-snap during the drag:
 *   The wrapper has `scroll-behavior: smooth` (CSS) and `scroll-snap-type: x mandatory`
 *   (set by Swiper cssMode). Both fight per-frame scrollLeft writes, so we disable them
 *   while dragging and restore them on release — leaving wheel/trackpad/touch untouched.
 *
 * Delegated + globally guarded so it is safe to include once per section instance and
 * keeps working for sections (re)rendered in the theme editor.
 */
(function () {
  if (window.__opBoutiquesCarouselDrag) return;
  window.__opBoutiquesCarouselDrag = true;

  var SELECTOR = '.op-boutiques-carousel__slider .swiper-wrapper';
  var DRAG_THRESHOLD = 3;

  var el = null;
  var moved = false;
  var startX = 0;
  var startScroll = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return; // touch/trackpad keep native scrolling
    var wrap = e.target.closest(SELECTOR);
    if (!wrap) return;
    el = wrap;
    moved = false;
    startX = e.pageX;
    startScroll = wrap.scrollLeft;
    wrap.style.scrollBehavior = 'auto';
    wrap.style.scrollSnapType = 'none';
    wrap.style.cursor = 'grabbing';
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!el) return;
    var dx = e.pageX - startX;
    if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
    el.scrollLeft = startScroll - dx;
  }, true);

  document.addEventListener('pointerup', function () {
    if (!el) return;
    el.style.scrollBehavior = '';
    el.style.scrollSnapType = '';
    el.style.cursor = '';
    el = null;
  }, true);

  // Block the browser's native image/link drag inside the carousel.
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest(SELECTOR)) e.preventDefault();
  }, true);

  // Suppress link navigation when the press was actually a drag.
  document.addEventListener('click', function (e) {
    if (moved && e.target.closest(SELECTOR)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
